export const resultsData = {
  model1: {
    id: "M1",
    title: "AI Money Model – Poco Tempo",
    desc: "Il tuo profilo è ideale per sistemi ad alta automazione che richiedono bassa manutenzione operativa.",
    buttonText: "Accedi al Model 1 – Poco Tempo",
    link: "https://elkqr.link/COMMUNITYAIMONEYMODELS",
    color: "from-blue-500 to-cyan-400"
  },
  model2: {
    id: "M2",
    title: "AI Money Model – Costruttore di Sistema",
    desc: "Hai la mentalità e l'energia per scalare una struttura solida e duratura nel tempo.",
    buttonText: "Accedi al Model 2 – Costruttore di Sistema",
    link: "https://elkqr.link/COMMUNITYAIMONEYMODELS",
    color: "from-orange-500 to-red-500"
  },
  model3: {
    id: "M3",
    title: "AI Money Model – Professione Digitale",
    desc: "La tua predisposizione alla relazione e all'azione quotidiana ti rende perfetto per le nuove professioni AI-Driven.",
    buttonText: "Accedi al Model 3 – Professione Digitale",
    link: "https://elkqr.link/COMMUNITYAIMONEYMODELS",
    color: "from-purple-500 to-indigo-500"
  }
};